
import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import CampaignTypeCard from '../CampaignTypeCard';
import { CampaignType } from '../types';

interface CampaignTypesSectionProps {
  campaignTypes: CampaignType[];
  onSelect: (type: string) => void;
}

const CampaignTypesSection: React.FC<CampaignTypesSectionProps> = ({
  campaignTypes,
  onSelect,
}) => {
  return (
    <Card className="campaign-types-card">
      <CardHeader>
        <CardTitle>Campaign Types</CardTitle>
        <CardDescription>
          Select a campaign type to set up a new referral marketing initiative
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {campaignTypes.map(campaign => (
            <CampaignTypeCard
              key={campaign.id}
              campaign={campaign}
              onSelect={() => onSelect(campaign.id)}
            />
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default CampaignTypesSection;
